import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../../config/axios.config';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';

export const VerifyOtpApi: any = createAsyncThunk('verifyOtpApi', async (input: any) => {
	try {
		const { headers } = input;
		const { data } = await API.post(API_ENDPOINTS.VERIFY_OTP, {}, { headers });
		return data;
	} catch (verifyOtpError: any) {
		return verifyOtpError?.response?.data;
	}
});

const VerifyOtpSlice = createSlice({
	name: 'verifyOtpApi',
	initialState: {
		verifyOtpRes: [],
		verifyOtpLoad: false,
		verifyOtpError: ''
	},
	reducers: {
		reset: (state) => {
			state.verifyOtpRes = [];
			state.verifyOtpLoad = false;
			state.verifyOtpError = '';
		}
	},
	extraReducers: (builder) => {
		builder.addCase(VerifyOtpApi.fulfilled, (state, action: any) => {
			state.verifyOtpLoad = false;
			state.verifyOtpRes = action.payload;
			state.verifyOtpError = '';
		});

		builder.addCase(VerifyOtpApi.pending, (state) => {
			state.verifyOtpLoad = true;
		});

		builder.addCase(VerifyOtpApi.rejected, (state, action: any) => {
			state.verifyOtpLoad = false;
			state.verifyOtpRes = [];
			state.verifyOtpError = action.payload;
		});
	}
});

export const { reset: resetVerifyOtp } = VerifyOtpSlice.actions;
export const VerifyOtpApiSlice = VerifyOtpSlice.reducer;
